<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn icon dark @click="$emit('close')">
                <v-icon class="notranslate">close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $t('Compare plans') }}</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="plans_comparison_container">
            <p class="text-xs-center" v-html="$t('There\'s two plans for this segment')"></p>
            <table class="plans_comparison_table">
                <tr>
                    <th></th>
                    <th>Pro</th>
                    <th>Basic</th>
                </tr>
                <tr>
                    <td>{{ $t('plans_comparison_1') }}</td>
                    <td><span class="material-icons notranslate">done</span></td>
                    <td><span class="material-icons notranslate">clear</span></td>
                </tr>
                <tr>
                    <td>{{ $t('plans_comparison_2') }}</td>
                    <td><span class="material-icons notranslate">done</span></td>
                    <td><span class="material-icons notranslate">clear</span></td>
                </tr>
                <tr>
                    <td>{{ $t('plans_comparison_3') }}</td>
                    <td><span class="material-icons notranslate">done</span></td>
                    <td><span class="material-icons notranslate">clear</span></td>
                </tr>
                <tr>
                    <td>{{ $t('plans_comparison_4') }}</td>
                    <td><span class="material-icons notranslate">done</span></td>
                    <td><span class="material-icons notranslate">done</span></td>
                </tr>
                <tr>
                    <td>{{ $t('plans_comparison_5') }}</td>
                    <td>7</td>
                    <td>1</td>
                </tr>
                <tr>
                    <td>{{ $t('plans_comparison_6') }}</td>
                    <td>1</td>
                    <td>0</td>
                </tr>
                <tr>
                    <td>{{ $t('plans_comparison_7') }}</td>
                    <td>{{ info.country.iso === 'br' ? 'R$ 6,70' : 'U$ 4.70' }}</td>
                    <td>{{ info.country.iso === 'br' ? 'R$ 13,40' : 'U$ 9.40' }}</td>
                </tr>
                <tr>
                    <td>{{ $t('plans_comparison_8') }}</td>
                    <td>{{ info.country.iso === 'br' ? 'R$ 40,70' : 'U$ 19.70' }}</td>
                    <td>{{ info.country.iso === 'br' ? 'R$ 81,40' : 'U$ 39.40' }}</td>
                </tr>
                <tr>
                    <td>{{ $t('plans_comparison_9') }}</td>
                    <td>12</td>
                    <td>4</td>
                </tr>
                <tr>
                    <td>{{ $t('plans_comparison_10') }}</td>
                    <td><span class="material-icons notranslate">done</span></td>
                    <td><span class="material-icons notranslate">done</span></td>
                </tr>
                <tr>
                    <td>{{ $t('plans_comparison_11') }}</td>
                    <td><span class="material-icons notranslate">done</span></td>
                    <td><span class="material-icons notranslate">clear</span></td>
                </tr>
                <tr>
                    <td>{{ $t('plans_comparison_12') }}</td>
                    <td><span class="material-icons notranslate">done</span></td>
                    <td><span class="material-icons notranslate">done</span></td>
                </tr>
                <tr>
                    <td>{{ $t('plans_comparison_13') }}</td>
                    <td><span class="material-icons notranslate">done</span></td>
                    <td><span class="material-icons notranslate">done</span></td>
                </tr>
                <tr>
                    <td>{{ $t('plans_comparison_14') }}</td>
                    <td><span class="material-icons notranslate">done</span></td>
                    <td><span class="material-icons notranslate">done</span></td>
                </tr>
            </table>
            <v-layout row wrap align-center justify-center>
                <SpecialOfferAlert v-if="show_special_offer_alert" :info="info"/>
                <v-btn large round color="#FDD835" class="my-0 ml-2 mr-4"
                       :disabled="loading" :loading="loading" @click="$emit('pay-membership')"
                >
                    {{ $t('Join the Pro plan') }}
                </v-btn>
            </v-layout>
            <v-layout row wrap align-center justify-center v-if="info['status'] !== 'active'">
              <v-btn large depressed :disabled="loading" :loading="loading"
                     class="mb-0 mx-3 mt-4"
                     @click="$emit('basic-plan-publish')"
                     v-html="$t('Proceed free on the Basic plan')"
              ></v-btn>
              <p class="text-xs-center">
                <small><em>{{ $t('free Basic plan offer is available for a limited time') }}</em></small>
              </p>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
  import VCard from 'vuetify/es5/components/VCard/VCard'
  import VIcon from 'vuetify/es5/components/VIcon/VIcon'
  import SpecialOfferAlert from "./SpecialOfferAlert";
  export default {
    name: "PlansComparison",
    components: {VCard, VIcon, SpecialOfferAlert},
    props: {
      info: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        required: true
      },
      show_special_offer_alert: {
        type: Boolean,
        required: true
      }
    },
  }
</script>

<style scoped>

</style>

<i18n>
    {
        "en": {
            "Compare plans": "Compare plans",
            "There's two plans for this segment": "For this segment, there are two options of membership plans available.<br> Check the differences in the comparative table below:",
            "plans_comparison_1": "Compete for the annual Golden Lens award",
            "plans_comparison_2": "Priority in the position of the list of professionals",
            "plans_comparison_3": "Access to publish interview",
            "plans_comparison_4": "Participation in the Inspiration Awards",
            "plans_comparison_5": "Free submissions per round of individual photo awards",
            "plans_comparison_6": "Free submissions per collection or film Awards round",
            "plans_comparison_7": "Cost per extra photo submitted to a contest",
            "plans_comparison_8": "Cost per collection or extra film submitted to a contest",
            "plans_comparison_9": "Quantity of media in the portfolio",
            "plans_comparison_10": "Access to Inspiration partner discounts",
            "plans_comparison_11": "Access to spontaneous judges' comments on contests",
            "plans_comparison_12": "Free Photo and Video Review analyzes according to the number of submissions at the Awards",
            "plans_comparison_13": "Access to result contestation",
            "plans_comparison_14": "Public profile with buttons for phone, website, social networks and request a quote",
            "Join the Pro plan": "Join the Pro plan",
            "Proceed free on the Basic plan": "Proceed with Basic plan<br>for free*",
            "free Basic plan offer is available for a limited time": "*The free Basic plan offer is available for a limited time and can be removed in the future without notice."
        },
        "pt": {
            "Compare plans": "Comparar planos",
            "There's two plans for this segment": "Para este segmento, há duas opções de planos de membresia disponíveis.<br>Confira as diferenças na tabela comparativa abaixo:",
            "plans_comparison_1": "Concorre ao prêmio anual Lente de Ouro",
            "plans_comparison_2": "Prioridade na posição da lista de profissionais",
            "plans_comparison_3": "Acesso para publicar entrevista",
            "plans_comparison_4": "Participação no Inspiration Awards",
            "plans_comparison_5": "Envios gratuitos por rodada de Awards de fotos individuais",
            "plans_comparison_6": "Envios gratuitos por rodada de Awards de coleções ou filmes",
            "plans_comparison_7": "Valor por foto extra enviada a um concurso",
            "plans_comparison_8": "Valor por coleção ou filme extra enviada a um concurso",
            "plans_comparison_9": "Quantidade de mídias no portfólio",
            "plans_comparison_10": "Acesso à descontos dos parceiros Inspiration",
            "plans_comparison_11": "Acesso a comentários espontâneos de jurados nos concursos",
            "plans_comparison_12": "Análises Photo e Video Review gratuitas conforme número de envios no Awards",
            "plans_comparison_13": "Acesso a contestação de resultado",
            "plans_comparison_14": "Perfil público com botões para telefone, site, redes sociais e solicitar orçamento",
            "Join the Pro plan": "Ingressar no plano Pro",
            "Proceed free on the Basic plan": "Prosseguir no plano Basic<br>(gratuito*)",
            "free Basic plan offer is available for a limited time": "*A oferta do plano Basic gratuito está disponível por tempo limitado e pode ser removida futuramente sem aviso prévio."
        }
    }
</i18n>
